import { MessageId } from 'intl/generated/messageIds';
import { Brand, make } from 'shared/types/brand';

export type TranslationKey = Brand<MessageId, 'TranslationKey'>;

export const translationKey = make<TranslationKey>();

/**
 * Unsafely converts an arbitrary string into a TranslationKey.
 * Use only when the value is guaranteed to be a valid MessageId.
 */
export const unsafeTranslationKey = (value: string): TranslationKey =>
  translationKey(value as MessageId);

/** Runtime string for broadcast APIs, Permission.reason, react-intl bridges. */
export function translationKeyToString(key: TranslationKey): string {
  return key as unknown as string;
}

export function translationKeyToStringOrNull(
  key: TranslationKey | null | undefined
): string | null | undefined {
  if (key == null) {
    return key ?? null;
  }
  return translationKeyToString(key);
}
